export default [
  {
    path: '/contentNewsList',
    name: 'contentNewsList',
    component: () => import('@views/contentNews/index.vue'),
    meta: {
      title: '邀工资讯'
    }
  },
  {
    path: '/contentNewsInfo',
    name: 'contentNewsInfo',
    component: () => import('@views/contentNews/detail.vue'),
    meta: {
      title: '邀工资讯'
    }
  }
]
